import React from 'react'
import { Box, Skeleton } from '@mui/material'

const BUTTON_SKELETON_HEIGHT = 53
/**
 * renders a skeleton for our list of manufacturers
 */
const ManufacturerLoading: React.VFC = () => {
  return (
    <Box>
      <Skeleton variant="rounded" sx={{ width: '100%', height: BUTTON_SKELETON_HEIGHT, mt: 1, mb: 2 }} />
      <Skeleton variant="rounded" sx={{ width: '100%', height: BUTTON_SKELETON_HEIGHT, mb: 2 }} />
      <Skeleton variant="rounded" sx={{ width: '100%', height: BUTTON_SKELETON_HEIGHT, mb: 2 }} />
      <Skeleton variant="rounded" sx={{ width: '100%', height: BUTTON_SKELETON_HEIGHT, mb: 2 }} />
    </Box>
  )
}

export default ManufacturerLoading
